export default function Toast({ toasts, onRemove }) {
    if (!toasts.length) return null

    const styles = {
        error:   { bg: "#fef2f2", border: "#fca5a5", text: "#b91c1c", icon: "✕" },
        success: { bg: "#f0fdf4", border: "#86efac", text: "#15803d", icon: "✓" },
        info:    { bg: "#eff6ff", border: "#93c5fd", text: "#1d4ed8", icon: "ℹ" },
    }

    return (
        <div style={{
            position: "fixed", top: "20px", right: "20px",
            zIndex: 99999, display: "flex", flexDirection: "column", gap: "10px",
            maxWidth: "380px", width: "calc(100vw - 40px)",
        }}>
            {toasts.map(t => {
                const s = styles[t.type] || styles.error
                return (
                    <div key={t.id} style={{
                        display: "flex", alignItems: "flex-start", gap: "10px",
                        background: s.bg, border: `1px solid ${s.border}`,
                        borderRadius: "10px", padding: "12px 14px",
                        boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                        animation: "toast-in 0.2s ease",
                    }}>
                        <span style={{ color: s.text, fontWeight: "700", fontSize: "14px", flexShrink: 0 }}>
                            {s.icon}
                        </span>
                        <span style={{ color: s.text, fontSize: "13px", lineHeight: "1.5", flex: 1 }}>
                            {t.message}
                        </span>
                        <button
                            onClick={() => onRemove(t.id)}
                            style={{
                                background: "none", border: "none", cursor: "pointer",
                                color: s.text, opacity: 0.6, fontSize: "16px",
                                lineHeight: 1, padding: 0, flexShrink: 0,
                            }}
                            aria-label="Dismiss"
                        >×</button>
                    </div>
                )
            })}
            <style>{`@keyframes toast-in { from { opacity:0; transform:translateY(-8px) } to { opacity:1; transform:translateY(0) } }`}</style>
        </div>
    )
}
